import type { ReviewType } from './api';

// Single source of nav truth for the review types this app exposes. A new type only needs an
// entry here (and, if its `itemToReview` shape actually diverges from the generic member-list
// rendering ReviewDetailView already does, a small addition there), never a new route or view.
export interface ReviewNavItem {
  reviewType: ReviewType;
  label: string;
  /** One sentence for the home page tile. Not shown in the sidebar. */
  description: string;
  /** Material Symbols ligature name. */
  icon: string;
}

export const reviewNavItems: ReviewNavItem[] = [
  {
    reviewType: 'aws',
    label: 'AWS Accounts',
    description: 'Review who still has access to the AWS accounts assigned to you.',
    icon: 'cloud',
  },
  {
    reviewType: 'github',
    label: 'GitHub Organizations',
    description: 'Review who still has access to the GitHub organizations assigned to you.',
    icon: 'code',
  },
  {
    reviewType: 'core-metadata',
    label: 'Core Metadata',
    description: 'Review who still has access manager rights on the ICP scopes you account for.',
    icon: 'inventory_2',
  },
];
